<div class="personal-title-slot text-c2-m-500 text-sm-c2-l-500 text-md-b3-s-500 text-lg-b3-m-500">
  @if (personalPrice && mainPrice && secondaryPrice) {
    ваша цена
  }
</div>
<div class="available">
  @if (mainPrice) {
    <span
      aria-label="Product price"
      class="price-main text-b4-m-900 text-sm-b2-s-900 text-md-b2-l-900 text-lg-b1-l-900"
    >
      {{ mainPrice.formattedValue }}
      @if (isRentProduct) {
        <span class="price-rent text-c1-m-300 text-md-b2-s-500 text-lg-b1-s-300">/ 24ч</span>
      }
    </span>
  }

  @if (secondaryPrice && !isRentProduct) {
    <span
      aria-label="Product price"
      class="price-secondary text-b4-s-900 text-xs-b4-m-900 text-sm-b4-m-900 text-md-b2-m-900 text-lg-b2-l-900 text-xl-b1-l-900"
      [class.cross-gray]="personalPrice"
    >
      {{ secondaryPrice.formattedValue }}
    </span>
  }
</div>
